import { Stack, Typography } from '@mui/material'
import { type SurveyContent } from '../../MidYear/Summary/MidYearSummary'
import { SummaryElement } from '../../MidYear/Summary/components/SummaryElement'
import { SurveyPriorityAccordionSummary } from '../../MidYear/Summary/components/SurveyPriorityAccordionSummary'

interface Props {
  content: SurveyContent
  answers: Record<string, any>
}
export const ISDEndOfYearSummary = ({ content, answers }: Props): JSX.Element => {
  const overallPage = content.pages.find(page => page.title.includes('Overall'))
  const priorityOnePage = content.pages.find(page => page.title.includes('Priority 1'))
  const priorityTwoPage = content.pages.find(page => page.title.includes('Priority 2'))
  const priorityThreePage = content.pages.find(page => page.title.includes('Priority 3'))
  const priorityFourPage = content.pages.find(page => page.title.includes('Priority 4'))
  const pointsOfPridePage = content.pages.find(page => page.title.includes('Points of Pride'))

  return (<Stack gap={2}>
    <Typography variant='h3'>
      ISD End of Year Progress Report
    </Typography>

    {overallPage != null && (
      <Stack gap='24px'>
        <Typography variant='h4'>{overallPage.title}</Typography>
        {overallPage.elements.map((element) => (
          <SummaryElement key={element.name} element={element} answers={answers} />
        ))}
      </Stack>
    )}

    {priorityOnePage != null && (
      <SurveyPriorityAccordionSummary
        priorityColor='var(--Theme-primitive-primary-500, rgba(0, 103, 165, 1))'
        title='Priority 1: Professional Learning & Resource Dissemination'
        page={priorityOnePage}
        answers={answers}
      />
    )}

    {priorityTwoPage != null && (
      <SurveyPriorityAccordionSummary
        priorityColor='var(--Theme-primitive-secondary-500, rgba(118, 102, 168, 1))'
        title='Priority 2 - Establishing a Coaching Structure'
        page={priorityTwoPage}
        answers={answers}
      />
    )}

    {priorityThreePage != null && (
      <SurveyPriorityAccordionSummary
        priorityColor='var(--Feedback-primitive-success-700, rgba(99, 141, 45, 1))'
        title='Priority 3 - Coaching for Implementation of Evidence-Based Practices (EBP)'
        page={priorityThreePage}
        answers={answers}
      />
    )}

    {priorityFourPage != null && (
      <SurveyPriorityAccordionSummary
        priorityColor='var(--Theme-primitive-tertiary-700, rgba(23, 124, 158, 1))'
        title='Priority 4 - Peer to Peer Support'
        page={priorityFourPage}
        answers={answers}
      />
    )}

    {pointsOfPridePage != null && (
      <Stack gap='24px'>
        <Typography variant='h4'>{pointsOfPridePage.title}</Typography>
        {pointsOfPridePage.elements.map((element) => (
          <SummaryElement key={element.name} element={element} answers={answers} />
        ))}
      </Stack>
    )}
  </Stack>)
}
